import React from "react";
import ReactDOM from "react-dom/client";
import { ContextProvider } from "./Context";
import { Show } from "./ModalContext";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import { AnimatePresence, motion } from "framer-motion";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import Best from "./components/pages/Best/Best"
import Library from "./components/pages/Library/Library";
import { BestByDate } from "./components/pages/BestByDate/BestByDate";
import Root from "./components//Root/Root";
import Home from "./components/pages/Home/Home";

const queryClient = new QueryClient();
const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/best",
        element: <Best />,
      },
      {
        path: "/best-by-date",
        element: <BestByDate />,
      },
      {
        path: "/library",
        element: <Library />,
      },
    ],
  },
]);
ReactDOM.createRoot(document.getElementById("root")).render(
  <QueryClientProvider client={queryClient}>
    <ContextProvider>
      <Show>
        {/* <AnimatePresence mode="wait" initial={true}> */}
        <RouterProvider router={router} />
        {/* </AnimatePresence> */}
      </Show>
      <ReactQueryDevtools initialIsOpen={false} />
    </ContextProvider>
  </QueryClientProvider>
);
